import { createSlice } from "@reduxjs/toolkit";
import { getAllDropDowns, deleteDropDown, createDropDown, editDropDown } from "../API/DropDownApi";

const initialState = {
    getallDropDowns: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const DropDownSlice = createSlice({
  name: "DropDown",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDropDowns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDropDowns.fulfilled, (state, action) => {
        state.loading = false;
        state.getallDropDowns = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllDropDowns.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })

      .addCase(deleteDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteDropDown = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(deleteDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.createDropDown = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(createDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(editDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.editDropDown = [action.payload];
        state.error = null;
      })
      .addCase(editDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DropDownSlice.reducer;